import React, { FC, useRef, useState } from 'react';
import MainBox from 'src/components/molecules/contentLayout/MainBox';
import TitleContent from 'src/components/molecules/contentLayout/TitleContent';
import TotalIncome from './TotalIncome';
import WorkingPeriod from './WorkingPeriod';
import CurrentWork from './CurrentWork';
import BeforeWork from './BeforeWork';
import '../../style.scss';
import './style.scss';

interface Props {
  num: number;
}

const StepB: FC<Props> = ({ num }) => {
  const confirmEvt = () => {
    console.log('CONFIRM!');
  };
  const boxRef = useRef<HTMLDivElement | null>(null);

  const middleContent = () => {
    return (
      <div className="_temp_content_layout" ref={boxRef}>
        <div className="_info_step">
          <section className="_section_layout">
            <TitleContent label="총소득" vtype="t2" content={<TotalIncome />} />
          </section>
          <section className="_section_layout">
            <TitleContent label="근로기간" vtype="t2" content={<WorkingPeriod />} />
          </section>
          <section className="_section_layout _t4">
            <TitleContent label="현재 근무지(급여정보)" vtype="t2" content={<CurrentWork />} />
          </section>
          <section className="_section_layout">
            <TitleContent label="종전 근무지" vtype="t2" content={<BeforeWork />} />
          </section>
        </div>
      </div>
    );
  };
  return (
    <MainBox
      label="연간소득 정보"
      icon="ri-wallet-3-line"
      desc=<div>
        부양가족의 연간소득금액이 세법상 인적공제 요건을 충족하는지 반드시 확인하시기 바랍니다.{' '}
        <br />
        소득요건을 충족하지 않는 경우 인적공제 대상에서 제외될 수 있으며, 잘못 신청한 경우 추후
        세액이 추징될 수 있습니다.
      </div>
      content={middleContent()}
      num={num}
      confitmEvent={confirmEvt}
      viewType="slide"
    />
  );
};

export default StepB;
